import Vue from 'vue';
import App from './App.vue';
import router from './router';

Vue.config.productionTip = false;
// vue-shortkey permet de gérer les raccourcis. Utilisé dans ce projet pour passer d'une couleur à une autre dans le
// test
Vue.use(require('vue-shortkey'));

new Vue({
    router,
    render: h => h(App)
}).$mount('#app');
